import './styles.scss';

// SIZES => big / middle / small / super-small
const GradientText = ({ children, size = 'big', textColor = 'black', className = '' }) => (
    <div className={`gradient-text gradient-text--${size} gradient-text--${textColor} ${className}`}>{children}</div>
);

export default GradientText;
